<template>
    <div ref="container" class="kv-audio-player" :class="{ 'audio-playing': isPlaying }">
        <div class="kv-play" @click="togglePlay">
            <!-- <Icon size="8" :icon-class="isPlaying ? 'ui-pause-circle' : 'ui-play-circle'" /> -->
            <div>

                <svg v-if="isPlaying" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.66667 2.5H5.16667C4.23325 2.5 3.76654 2.5 3.41002 2.68166C3.09641 2.84144 2.84144 3.09641 2.68166 3.41002C2.5 3.76654 2.5 4.23325 2.5 5.16667V14.8333C2.5 15.7668 2.5 16.2335 2.68166 16.59C2.84144 16.9036 3.09641 17.1586 3.41002 17.3183C3.76654 17.5 4.23325 17.5 5.16667 17.5H5.66667C6.60009 17.5 7.0668 17.5 7.42332 17.3183C7.73692 17.1586 7.99189 16.9036 8.15168 16.59C8.33333 16.2335 8.33333 15.7668 8.33333 14.8333V5.16667C8.33333 4.23325 8.33333 3.76654 8.15168 3.41002C7.99189 3.09641 7.73692 2.84144 7.42332 2.68166C7.0668 2.5 6.60009 2.5 5.66667 2.5Z" stroke="#FCFCFD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M14.8333 2.5H14.3333C13.3999 2.5 12.9332 2.5 12.5767 2.68166C12.2631 2.84144 12.0081 3.09641 11.8483 3.41002C11.6667 3.76654 11.6667 4.23325 11.6667 5.16667V14.8333C11.6667 15.7668 11.6667 16.2335 11.8483 16.59C12.0081 16.9036 12.2631 17.1586 12.5767 17.3183C12.9332 17.5 13.3999 17.5 14.3333 17.5H14.8333C15.7668 17.5 16.2335 17.5 16.59 17.3183C16.9036 17.1586 17.1586 16.9036 17.3183 16.59C17.5 16.2335 17.5 15.7668 17.5 14.8333V5.16667C17.5 4.23325 17.5 3.76654 17.3183 3.41002C17.1586 3.09641 16.9036 2.84144 16.59 2.68166C16.2335 2.5 15.7668 2.5 14.8333 2.5Z" stroke="#FCFCFD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>

                <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.1665 4.15797C4.1665 3.34866 4.1665 2.94401 4.33525 2.72095C4.48225 2.52663 4.70694 2.40638 4.95017 2.39186C5.22937 2.37519 5.56606 2.59965 6.23944 3.04857L15.0024 8.89054C15.5588 9.26148 15.837 9.44695 15.934 9.68072C16.0187 9.8851 16.0187 10.1148 15.934 10.3192C15.837 10.5529 15.5588 10.7384 15.0024 11.1093L6.23944 16.9513C5.56606 17.4002 5.22937 17.6247 4.95017 17.608C4.70694 17.5935 4.48225 17.4733 4.33525 17.2789C4.1665 17.0559 4.1665 16.6512 4.1665 15.8419V4.15797Z" stroke="#FCFCFD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>


            </div>


        </div>

        <canvas ref="canvas" class="kv-audio-progress" :height="height" @click="seek" />

        <span class="kv-time">
            {{ formatTime(isPlaying ? currentTime : duration) }}
        </span>

        <div class="kv-volume-wrapper" @mouseenter="showVolume = true" @mouseleave="showVolume = false">
            <div class="kv-volume-icon" @click="toggleMute">
                <Icon size="6" :icon-class="volumeIcon" />
            </div>

            <input class="kv-volume" type="range" min="0" max="1" step="0.01" v-model.number="volume" @input="applyVolume" />
        </div>

        <audio ref="audio" :src="source" @timeupdate="onTimeUpdate" @loadedmetadata="onLoadedMetadata" @play="onPlay" @pause="onPause" />
    </div>
</template>

<script>
import Icon from "../icon/icon.vue";

export default {
    name: "KvAudioPlayer",
    components: { Icon },

    props: {
        source: { type: String, required: true },
        barWidth: { type: Number, default: 3 },
        gap: { type: Number, default: 3 },
        height: { type: Number, default: 44 },
        color: { type: String, default: "#209941" },
        inactiveColor: { type: String, default: "#6C737F" },
    },

    data() {
        return {
            ctx: null,
            dpr: window.devicePixelRatio || 1,
            width: 0,
            bars: 0,
            barHeights: [],
            isPlaying: false,
            animationId: null,
            currentTime: 0,
            duration: 0,
            // resizeObserver: null,
            volume: 1,
            lastVolume: 1,
            showVolume: false,
            isMuted: false,

            waves: []
        };
    },

    async mounted() {
        // this.setAudioWaves();
        this.ctx = this.$refs.canvas.getContext("2d");
        // this.observeResize();
        await this.updateCanvas();
        // this.setAudioWaves();
    },

    beforeUnmount() {
        // this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.animationId);
    },

    methods: {
        async getAudioWaves(samples = 256) {
            // Cria o AudioContext
            const audioCtx = new (window.AudioContext || window.webkitAudioContext)();

            // Busca o arquivo de áudio
            const response = await fetch(this.source);
            const arrayBuffer = await response.arrayBuffer();

            // Decodifica o áudio do ArrayBuffer
            const audioBuffer = await audioCtx.decodeAudioData(arrayBuffer);

            // Pega o canal principal (geralmente 0)
            const channelData = audioBuffer.getChannelData(0);

            const blockSize = Math.floor(channelData.length / samples);

            const totalSamples = channelData.length;

            const amplitudes = [];
            let maxRMS = 0;

            // 4. Calcula RMS por bloco
            for (let i = 0; i < samples; i++) {
                let sum = 0;
                const start = i * blockSize;
                const end = Math.min(start + blockSize, totalSamples);

                for (let j = start; j < end; j++) {
                    sum += channelData[j] * channelData[j];
                }

                const rms = Math.sqrt(sum / (end - start || 1));
                amplitudes.push(rms);
                if (rms > maxRMS) maxRMS = rms;
            }

            const normalized = amplitudes.map(v => {
                if (!maxRMS) return 0;
                let val = v / maxRMS; // Normalização linear 0 a 1

                // COMPRESSÃO: Aplica raiz quadrada para dar mais ganho visual aos sons baixos
                // Isso faz com que 0.01 vire 0.1, dando corpo às barras pequenas.
                val = Math.sqrt(val);

                // Opcional: Filtro de ruído (se for quase zero, vira zero de verdade)
                return val > 0.05 ? val : 0;
            });

            return normalized;
        },

        /* ---------- volume ---------- */
        applyVolume() {
            const audio = this.$refs.audio;
            audio.volume = this.volume;
            this.isMuted = this.volume === 0;
        },

        toggleMute() {
            const audio = this.$refs.audio;
            if (this.isMuted || audio.volume === 0) {
                this.volume = this.lastVolume || 1;
                audio.volume = this.volume;
                this.isMuted = false;
            } else {
                this.lastVolume = this.volume;
                this.volume = 0;
                audio.volume = 0;
                this.isMuted = true;
            }
        },

        /* ---------- resize ---------- */
        // observeResize() {
        //     this.resizeObserver = new ResizeObserver(this.updateCanvas);
        //     this.resizeObserver.observe(this.$refs.container);
        // },

        async updateCanvas() {
            const canvas = this.$refs.canvas;

            // Define o Width como sendo o width disponível (algo como 100%, ou 1fr)
            const rect = canvas.getBoundingClientRect();
            this.width = Math.floor(rect.width);

            console.log(window.devicePixelRatio);
            // Define o Canvas como sendo o width e height disponível junto com o ratio da janela
            canvas.width = this.width * this.dpr;
            canvas.height = this.height * this.dpr;

            // Definimos o max-width para que o canvas consiga diminuir
            canvas.style.maxWidth = `${this.width}px`;
            canvas.style.height = `${this.height}px`;

            this.calculateBars();
            await this.generateBars();
            this.draw();
        },

        calculateBars() {
            // Calculo de total de barras dado a largura das barras e o espaço entre elas
            const total = this.barWidth + this.gap;

            this.bars = Math.floor(this.width / total);
        },

        async generateBars() {
            // Definimos a altura das barras de forma aleatória
            const len = this.bars;
            const maxH = this.height * 0.6;
            this.barHeights = new Array(len);

            const barHeights = await this.getAudioWaves(len);
            console.log(barHeights);
            for (let i = 0; i < len; i++) {
                this.barHeights[i] = barHeights[i] * maxH + 6;
            }
        },

        // generateWaveform() {
        //     this.calculateBars();
        //     this.generateBars();
        // },

        /* ---------- audio ---------- */
        togglePlay() {
            const audio = this.$refs.audio;
            audio.paused ? audio.play() : audio.pause();
        },

        onPlay() {
            this.isPlaying = true;
            this.animate();
        },

        onPause() {
            this.isPlaying = false;
            cancelAnimationFrame(this.animationId);
        },

        onLoadedMetadata() {
            const audio = this.$refs.audio;
            this.duration = audio.duration || 0;
            audio.volume = this.volume;
        },

        onTimeUpdate() {
            this.currentTime = this.$refs.audio.currentTime || 0;
        },

        /* ---------- animation ---------- */
        animate: function () {
            this.draw();
            if (this.isPlaying) {
                this.animationId = requestAnimationFrame(this.animate);
            }
        },

        /* ---------- draw ---------- */
        draw() {
            const { ctx, width, height, barHeights, barWidth, gap, color, inactiveColor } = this;
            const audio = this.$refs.audio;
            // Progresso em porcentagem
            const progress = audio.duration > 0 ? audio.currentTime / audio.duration : 0;

            ctx.clearRect(0, 0, width, height);

            for (let i = 0, len = barHeights.length; i < len; i++) {
                // Pegamos a altura definida anteriormente
                const h = barHeights[i];

                // Definimos a posição x (sendo indice * (largura da barra + espaço entre as barras))
                const x = i * (barWidth + gap);

                // O boolean played define true se o índice dividio pela quantidade total de barras for menor ou igual ao progresso, ou seja, a gente basicamente vê se ele está dentro do progresso
                const played = i / len <= progress;

                // Definimos a cor dele se ele estiver dentro do progresso
                ctx.fillStyle = played ? color : inactiveColor;

                // Definimos a posição y para sempre ficar centralizado
                const y = height / 2 - h / 2;

                // Definimos o raio
                const radius = barWidth / 2;

                ctx.beginPath();
                ctx.roundRect(x, y, barWidth, h, radius);
                ctx.fill();
            }
        },

        /* ---------- seek ---------- */
        seek(e) {
            const rect = this.$refs.canvas.getBoundingClientRect();
            const percent = (e.clientX - rect.left) / rect.width;
            this.$refs.audio.currentTime = percent * this.$refs.audio.duration;
            this.draw();
        },

        /* ---------- utils ---------- */
        formatTime(time) {
            if (!time) return "0:00";
            const m = Math.floor(time / 60);
            const s = Math.floor(time % 60).toString().padStart(2, "0");
            return `${m}:${s}`;
        },
    },

    computed: {
        volumeIcon() {
            if (this.isMuted || this.volume === 0) return "ui-volume-x";
            if (this.volume < 0.5) return "ui-volume-min";
            return "ui-volume-max";
        },
    },
};
</script>


<style lang="less">
.kv-audio-player {
    display: grid;
    grid-template-columns: auto 1fr 40px auto;
    align-items: center;
    gap: 12px;
    user-select: none;

    .kv-time {
        color: #384250;
        font-size: 14px;
        font-weight: 500;
        justify-self: center;
    }

    &.audio-playing {
        .kv-time {
            color: #2AAA4C;
        }
    }

    .kv-volume-wrapper {
        display: flex;
        align-items: center;
        gap: 6px;
    }

    .kv-volume-icon {
        cursor: pointer;
        color: #384250;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    .kv-volume {
        width: 0;
        height: 4px;
        cursor: pointer;

        accent-color: #1D7836;

        opacity: 0;

        transition:
            width 0.2s ease,
            opacity 0.15s ease;

        pointer-events: none;
    }

    .kv-volume-wrapper:hover .kv-volume {
        width: 60px; // abre para a DIREITA
        opacity: 1;
        pointer-events: auto;
    }
}

.kv-play {
    width: 44px;
    height: 44px;
    border-radius: 8px;
    background: #209941;
    color: #fff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    // &.audio-playing {
    //     background: #E5E7EB;
    // }
}

.kv-audio-progress {
    width: 100%;
    cursor: pointer;

}
</style>
